import { registerBlock, registerRelationship } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const fetCycle: ContentBlock<"program"> = {
  id: makeId("program-fet-cycle"),
  kind: "program",
  tags: ["fet", "treatment"],
  title: "Frozen Embryo Transfer",
  subtitle:
    "Transfer a previously frozen embryo with a clinic-recorded care plan",
  icon: "🎯",
  body: {
    duration: "Varies by protocol and clinic",
    includes: [
      "Endometrial preparation chosen by your clinic",
      "Monitoring and timing recorded by your care team",
      "Embryo transfer procedure",
      "Embryology and transfer outcome records",
      "A testing and follow-up plan from your care team",
    ],
    priceRange: { low: 3000, high: 6000 },
    currency: "USD",
    status: "coming-soon",
    category: "treatment",
    moduleIds: [makeId("module-embryo-transfer"), makeId("module-tww-support")],
    phases: [
      {
        title: "Preparation & Transfer",
        description: "Clinic-directed preparation and embryo transfer",
        moduleIds: [makeId("module-embryo-transfer")],
      },
      {
        title: "Two-Week Wait",
        description: "Support while you await your ordered follow-up",
        moduleIds: [makeId("module-tww-support")],
      },
    ],
    steps: [
      {
        title: "Endometrial prep",
        description:
          "Your clinic chooses the preparation, monitoring, and timing for this transfer.",
      },
      {
        title: "Transfer",
        description:
          "Your clinic records whether the thaw and planned transfer went ahead, including any cancellation or no-transfer outcome.",
      },
      {
        title: "Wait & test",
        description:
          "Your care team records the ordered test and follow-up plan; timing and medication instructions vary by protocol.",
      },
    ],
  },
  sources: [
    {
      title: "Frozen embryo transfer: a clinical review",
      journal: "Human Reproduction Update",
      year: 2022,
      evidenceLevel: "meta-analysis",
    },
  ],
};

registerBlock(fetCycle);

const id = makeId("program-fet-cycle");
registerRelationship({
  from: id,
  to: makeId("module-embryo-transfer"),
  type: "contains",
});
registerRelationship({
  from: id,
  to: makeId("module-tww-support"),
  type: "contains",
});
